export function frames(num) {
  return num * 16.7;
}
